"use strict";exports.sleep=function(e){return void 0===e&&(e=0),new Promise((function(t){return setTimeout(t,e)}))};
//# sourceMappingURL=sleep.cjs.map
